import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[3]}`,
    borderBottom: `1px solid ${projectIqTokens.sidebarBorder}`,
    flexShrink: 0,
    minHeight: "52px",
  },
  sidebarHeaderCollapsed: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: `${designTokens.spacing[2]} 0`,
    gap: designTokens.spacing[1],
    borderBottom: "none",
  },
  nhLogo: {
    width: "28px",
    height: "28px",
    minWidth: "28px",
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: projectIqTokens.sidebarAccent,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: designTokens.neutral.white,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.bold,
    flexShrink: 0,
    letterSpacing: "0.5px",
  },
  headerTitle: {
    flex: 1,
    fontWeight: designTokens.fontWeight.semibold,
    fontSize: designTokens.fontSize.base,
    color: designTokens.neutral.white,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    transition: `opacity ${designTokens.transition.fast}`,
  },
  headerTitleHidden: {
    display: "none",
  },
  collapseButton: {
    minWidth: "unset",
    padding: designTokens.spacing[1],
    color: projectIqTokens.sidebarFadedText,
    flexShrink: 0,
    ":hover": { color: designTokens.neutral.white },
  },
});
